import { createSlice } from '@reduxjs/toolkit'
import { getLanguageCode, setLanguageCode } from 'src/i18n'

interface LayoutState {
  loading: boolean
  menuVisible: boolean
  language: string
}
const initialState: LayoutState = {
  menuVisible: true,
  language: getLanguageCode(),
  loading: false,
}

const layoutSlice = createSlice({
  name: 'layoutSlice',
  initialState: initialState,
  reducers: {
    toggleMenu: (state) => {
      state.menuVisible = !state.menuVisible
    },
    showMenu: (state) => {
      state.menuVisible = true
    },
    hideMenu: (state) => {
      state.menuVisible = true
    },
    changeLanguage: (state, action) => {
      setLanguageCode(action.payload.language)

      /**
       * I18n is outside Redux store,
       * no we need this hack to load it properly
       */
      ;(window as any).location.reload()
    },
  },
})

export default layoutSlice
